import { render, staticRenderFns } from "./CMultiSelect.vue?vue&type=template&id=2809dba6&scoped=true&"
import script from "./CMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./CMultiSelect.vue?vue&type=script&lang=ts&"
import style0 from "./CMultiSelect.vue?vue&type=style&index=0&id=2809dba6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2809dba6",
  null
  
)

export default component.exports